import { Card, Grid, Header } from '@mairistem/composants';
import { UserRole } from '@mairistem/finances-utils';
import React from 'react';
import type BaseOutil from '../../classes/outils/BaseOutil';
import CalculRAR from '../../classes/outils/CalculRAR';
import CalculVirementCredit from '../../classes/outils/CalculVirementCredit';
import ControleCoherence from '../../classes/outils/ControleCoherence';
import ImportExportExcel from '../../classes/outils/ImportExportExcel';
import RecopieReport from '../../classes/outils/RecopieReport';
import type Simulation from '../../interfaces/simulation/simulation';
import Outil from './Outils/Outil';
import './BoiteOutil.css';

interface BoiteOutilProps {
	onRefresh: () => void;
	simulation: Simulation;
	userRole: UserRole;
}

const BoiteOutil = ({
	onRefresh,
	simulation,
	userRole = UserRole.NORMAL,
}: BoiteOutilProps) => {
	const [open, setOpen] = React.useState<boolean>(false);
	const [selectedOutil, setSelectedOutil] = React.useState<BaseOutil>();

	const handleClickOutil = (outil: BaseOutil) => {
		setSelectedOutil(outil);
		setOpen(true);
	};

	const handleClose = () => setOpen(false);

	const handleValidate = () => {
		setOpen(false);
		onRefresh?.();
	};

	const outils: BaseOutil[] = [
		new RecopieReport(simulation),
		// new RecuperationDonneeConnexe(),
		new ImportExportExcel(),
		new CalculVirementCredit(),
		new CalculRAR(),
		new ControleCoherence(simulation),
	];

	return (
		<>
			<Card className="boiteOutil" fluid>
				<Card.Content>
					<Card.Header as={Header} content="BOÎTE À OUTILS" size="tiny" />
					<Card.Description>
						<Grid padded>
							<Grid.Row className="nowrap">
								{outils?.map(
									(outil) =>
										outil?.isEnabled(userRole, simulation) && (
											<Grid.Column
												data-testid={`outil${outil?.code}`}
												onClick={() => handleClickOutil(outil)}
												key={outil?.code}
												width={3}
											>
												<Outil icon={outil?.icon} title={outil?.title} />
											</Grid.Column>
										),
								)}
							</Grid.Row>
						</Grid>
					</Card.Description>
				</Card.Content>
			</Card>
			{selectedOutil?.renderModal(
				simulation,
				handleClose,
				handleValidate,
				open,
			)}
		</>
	);
};

export default BoiteOutil;
